import TvGuide from './components/tv-guide';

export { TvGuide };

export default TvGuide;
